import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React, {useEffect, useState} from "react";
import EventBus from "../../EventBus";
import {EventBusEventsEnum} from "../../enums/EventBusEventsEnum";
import {CustomSnackbarTypes} from "./CustomSnackBar";
import moment from 'moment';
import { TimeEnum } from "../../enums/TimeEnum";
import { ChefForPartyBookingTypeEnum } from "../../enums/ChefForPartyBookingTypeEnum";

interface Props {
  data: any;
  open: boolean;
  callback: () => void;
  forCook?: boolean;
}

const ChefOrderSummaryDialog = (props: Props) => {
  const [bartender, setBartender] = useState(0);
  const [waiter, setWaiter] = useState(0);


  useEffect(() => {
    if(!props?.data) {
      return;
    }
    props?.data?.orders?.map((eachOrder: any) => {
      if(eachOrder?.orderItems?.length !== 0){
        eachOrder?.orderItems.map((eachOrderItem: any) => {
          if(eachOrderItem?.serviceAddons?.id === 1){
            setBartender(prevState => prevState += Number(eachOrderItem?.quantity));
          }
          if(eachOrderItem?.serviceAddons?.id === 2){
            setWaiter(prevState => prevState += Number(eachOrderItem?.quantity));
          }
          return eachOrderItem;
        })
      }
      return eachOrder;
    })
  }, [props?.data])

  function getTypeOfEvent(time: TimeEnum): string {
    const dinnerStart = TimeEnum.PM_03_00; // 3:00 PM is the starting time for dinner
    const timeMap = Object.values(TimeEnum); // List of all enum values

    // Find the index of the current time and the dinner start time
    const timeIndex = timeMap.indexOf(time);
    const dinnerStartIndex = timeMap.indexOf(dinnerStart);

    if (timeIndex >= dinnerStartIndex) {
        return "Dinner";
    } else {
        return "Lunch";
    }
  }

  function getCookPayout(cooks: any[]): any[] {
    if (!cooks || cooks.length === 0) return ['0'];
    return cooks.filter((cook: any) => cook?.type === "MAIN_CHEF").map((cook: any) => cook?.details?.cookCut)
  }


  const isBookByDish = props?.data?.bookingType === ChefForPartyBookingTypeEnum.BOOK_BY_DISH;
  const cookingTimeMins = Number(props?.data?.cookingTime ?? 0);
  const chefStayTill = isBookByDish
    ? `${props?.data?.time} + ${cookingTimeMins} min (${Number((cookingTimeMins / 60).toFixed(2))} hrs)`
    : `${props?.data?.time}+ 120 mins/ 2hrs`;

  const houseLat = props?.data?.house?.lat;
  const houseLong = props?.data?.house?.long;
  const locationMapLink = houseLat && houseLong
    ? `https://www.google.com/maps/search/?api=1&query=${houseLat},${houseLong}`
    : null;

  const message = `Order Summary

  Dear ${props?.data?.customerName},

  Thank you for completing the payment for your upcoming event with ChefKart! 🎉
    
  We’re excited to be part of your celebration.
    
  Event Details:
  
  📅 Date: ${moment(props?.data?.date).format('Do MMMM YYYY')}
  ⏰ Time: ${props?.data?.time}
  📍 Address: ${[
    props?.data?.house?.address,
    props?.data?.house?.localityName,
    props?.data?.house?.areaName,
    props?.data?.house?.cityName,
  ].filter(Boolean).join(', ')}
${isBookByDish ? '' : `  👨‍👩‍👧‍👦 Guests: ${props?.data?.noOfAdults} Adults | ${props?.data?.noOfChildren} Children
  🍴 Number of Waiters: ${waiter || 0}
  🍹 Number of Bartenders: ${bartender || 0}
`}
  🍽️ Menu: ${
    props?.data?.dishes
      ?.filter((eachDish: any) => eachDish?.deletedAt === null)
      ?.map((eachDish: any) => eachDish?.dishName)
      ?.join(', ') || 'N/A'
  }

  👨‍🍳 Chef Allocation

  • Chef is assigned 3 days before the event  
  • If payment is made within 3 days, chef will be assigned at the earliest  
  • Chef details will be visible on the ChefKart application, and you can connect via the call button
  
  📝 Ingredients & Utensils :

  • Chef will share a consolidated ingredient list on the application  
  • All ingredients and utensils must be arranged by you  
  • Utensils are not provided by ChefKart

  
${isBookByDish ? '' : `  ⏰ Arrival & Stay

  • Chef arrives 3–4 hours before the event  
  • Chef stays up to 2 hours after serving time  
  • Extra stay: ₹500/hour (paid directly to the chef)
  
`}  🧼 Cleanliness

  • Chef will leave the kitchen tidy (clean stove & countertops)  
  • Utensil washing is not included
  
  We look forward to making your event truly special ✨
  Enjoy a seamless and delightful ChefKart experience!

  Warm regards,
  Team ChefKart 👩‍🍳👨‍🍳`;
const message2 = `Event Summary:
    🎉 Type Of Event: ${getTypeOfEvent(props?.data?.time)}
    👨🏻‍💼 Customer Name: ${props?.data?.customerName}
    📅 Date of Event: ${moment(props?.data?.date).format('Do MMMM YYYY')}
    🕘 Chef Arrival Time: ${props?.data?.chefArrivalTime || 'N/A'}
${isBookByDish ? '' : `    ⏰ Food to be ready by: ${props?.data?.time}\n`}    📍 Location: ${locationMapLink || props?.data?.cityName}
    📍 Address: ${[props?.data?.house?.address, props?.data?.house?.localityName, props?.data?.house?.areaName, props?.data?.house?.cityName]?.filter((each) => each !== null).join(', ')}
    🍽️ Menu: ${props?.data?.dishes?.filter((eachDish: any) => eachDish?.deletedAt === null)?.map((eachDish: any) => eachDish?.dishName)?.join(', ') || 'N/A'}
${isBookByDish ? '' : `    👨‍👩‍👧‍👦 Number of Pax: ${props?.data?.noOfAdults}+${props?.data?.noOfChildren} (adult+children)\n`}    💵 Payout: ₹${getCookPayout(props?.data?.cooks)[0]}
    ⏰ Chef to Stay Till: ${chefStayTill}
    💵 Cash Collection: ₹${props?.data?.netPayableAmount}
`

const whatsAppMessage = `*Order Summary*

*Dear ${props?.data?.customerName},*

Thank you for completing the payment for your upcoming event with ChefKart! 🎉

We’re excited to be part of your celebration.

*Event Details:*

📅 *Date:* ${moment(props?.data?.date).format('Do MMMM YYYY')}
⏰ *Time:* ${props?.data?.time}
📍 *Address:* ${[
  props?.data?.house?.address,
  props?.data?.house?.localityName,
  props?.data?.house?.areaName,
  props?.data?.house?.cityName,
].filter(Boolean).join(', ')}
${isBookByDish ? '' : `👨‍👩‍👧‍👦 *Guests:* ${props?.data?.noOfAdults} Adults | ${props?.data?.noOfChildren} Children
🍴 Number of Waiters: ${waiter || 0}
🍹 Number of Bartenders: ${bartender || 0}
`}
🍽️ *Menu:* ${
  props?.data?.dishes
    ?.filter((eachDish: any) => eachDish?.deletedAt === null)
    ?.map((eachDish: any) => eachDish?.dishName)
    ?.join(', ') || 'N/A'
}

*👨‍🍳 Chef Allocation:*

• Chef is assigned 3 days before the event  
• If payment is made within 3 days, chef will be assigned at the earliest  
• Chef details will be visible on the ChefKart application, and you can connect via the call button

*📝 Ingredients & Utensils*

• Chef will share a consolidated ingredient list on the application  
• All ingredients and utensils must be arranged by you  
• Utensils are not provided by ChefKart

${isBookByDish ? '' : `*⏰ Arrival & Stay*

• Chef arrives 3–4 hours before the event  
• Chef stays up to 2 hours after serving time  
• Extra stay: ₹500/hour (paid directly to the chef)

`}*🧼 Cleanliness*

• Chef will leave the kitchen tidy (clean stove & countertops)  
• Utensil washing is not included

We look forward to making your event truly special ✨
Enjoy a seamless and delightful ChefKart experience!

Warm regards,
*Team ChefKart 👩‍🍳👨‍🍳*`;


  const handleCopy = () => {
    navigator.clipboard.writeText(!props?.forCook ? message : message2)
        .then(() => {
          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "Order Summary Copied Successfully",
            type: CustomSnackbarTypes.SUCCESS,
          });
        });
  };
  const handleCopyForWhatsApp = () => {
    navigator.clipboard.writeText(!props?.forCook ? whatsAppMessage : message2)
        .then(() => {
          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "Order Summary Copied Successfully",
            type: CustomSnackbarTypes.SUCCESS,
          });
        });
  };

  const handleClose = () => {
    props.callback();
  };

  return (
      <Dialog
          onClose={handleClose}
          open={props.open}
          scroll={"paper"}
          maxWidth="xl"
      >
        <DialogTitle>
          <Typography fontWeight={'600'}>
            {props?.forCook ? "Party Details" : "Order Summary"}
          </Typography>
        </DialogTitle>
        {
          !props?.forCook ? 
          <DialogContent>
              {/* Title */}
              <Typography
                component="div"
                sx={{ fontWeight: "bold", fontSize: "1.1rem", marginBottom: 2 }}
              >
                Order Summary
              </Typography>

              {/* Greeting */}
              <Typography
                component="div"
                sx={{ whiteSpace: "pre-wrap", lineHeight: 1.8, fontWeight: "bold", marginBottom: 2 }}
              >
                {`Dear ${props?.data?.customerName},`}
              </Typography>

              {/* Intro */}
              <Typography component="div" sx={{ lineHeight: 1.8, marginBottom: 2 }}>
                Thank you for completing the payment for your upcoming event with ChefKart! 🎉
              </Typography>

              {/* Chef allocation info */}
              <Typography component="div" sx={{ lineHeight: 1.8, marginBottom: 2 }}>
                We’re excited to be part of your celebration.
              </Typography>

              {/* Event Summary */}
              <Typography component="div" sx={{ fontWeight: "bold", marginBottom: 1 }}>
                Event Details:
              </Typography>

              <Typography component="div" sx={{ marginBottom: 1 }}>
                📅 <b>Date:</b> {moment(props?.data?.date).format("Do MMMM YYYY")}
              </Typography>

              <Typography component="div" sx={{ marginBottom: 1 }}>
                ⏰ <b>Time:</b> {props?.data?.time}
              </Typography>

              <Typography component="div" sx={{ marginBottom: 1 }}>
                📍 <b>Address:</b>{" "}
                {[
                  props?.data?.house?.address,
                  props?.data?.house?.localityName,
                  props?.data?.house?.areaName,
                  props?.data?.house?.cityName,
                ]
                  .filter(Boolean)
                  .join(", ")}
              </Typography>

              {!isBookByDish && (
                <>
                  <Typography component="div" sx={{ marginBottom: 1 }}>
                    👨‍👩‍👧‍👦 <b>Guests:</b> {props?.data?.noOfAdults} Adults | {props?.data?.noOfChildren} Children
                  </Typography>
                  <Typography component="div" sx={{ marginBottom: 1 }}>
                    🍹 <b>Number of Bartenders:</b> {bartender || 0}
                  </Typography>
                  <Typography component="div" sx={{ marginBottom: 2 }}>
                    🍴 <b>Number of Waiters:</b> {waiter || 0}
                  </Typography>
                </>
              )}

              <Typography component="div" sx={{ marginBottom: 1 }}>
                🍽️ <b>Menu:</b>{" "}
                {props?.data?.dishes
                  ?.filter((eachDish: any) => eachDish?.deletedAt === null)
                  ?.map((eachDish: any) => eachDish?.dishName)
                  ?.join(", ") || "N/A"}
              </Typography>

              {/* Ingredient note */}

              <br />

              <Typography component="div" sx={{ fontWeight: "bold", marginBottom: 1 }}>
                👨‍🍳 Chef Allocation
              </Typography>

              <Typography component="div" sx={{ marginBottom: 2 }}>
              <ul
                style={{
                  margin: 0,
                  paddingLeft: 20,
                  display: "flex",
                  flexDirection: "column",
                  gap: 6
                }}
              >
                <li>
                  Chef is assigned <b>3 days before the event.</b>
                </li>
                <li>
                  If payment is made within 3 days, chef will be assigned <b>at the earliest.</b>
                </li>
                <li>
                  Chef details will be visible on the <b>ChefKart application</b>, and you can connect via the <b>call button</b>.
                </li>
              </ul>
            </Typography>

              <br/>

              <Typography component="div" sx={{ fontWeight: "bold", marginBottom: 1 }}>
                📝 Ingredients & Utensils
              </Typography>

              <Typography component="div" sx={{ marginBottom: 2 }}>
              <ul
                style={{
                  margin: 0,
                  paddingLeft: 20,
                  display: "flex",
                  flexDirection: "column",
                  gap: 6
                }}
              >
                <li>
                  Chef will share a <b>consolidated ingredient list</b> on the application.
                </li>
                <li>
                  <b>All ingredients and utensils must be arranged by you.</b>
                </li>
                <li>
                  <b>Utensils are not provided by ChefKart.</b>
                </li>
              </ul>
            </Typography>

              <br />
              
              {!isBookByDish && (
                <>
                  {/* Arrival & Stay */}
                  <Typography component="div" sx={{ fontWeight: "bold", marginBottom: 1 }}>
                    ⏰ Arrival & Stay
                  </Typography>

                  <Typography component="div" sx={{ marginBottom: 2 }}>
                    <ul
                      style={{
                        margin: 0,
                        paddingLeft: 20,
                        display: "flex",
                        flexDirection: "column",
                        gap: 6
                      }}
                    >
                      <li>
                        Chef arrives <b>3–4 hours</b> before the event.
                      </li>
                      <li>
                        Chef stays <b>up to 2 hours after serving time.</b>
                      </li>
                      <li>
                        <b>Extra stay:</b> ₹500/hour (paid directly to the chef).
                      </li>
                    </ul>
                  </Typography>
                </>
              )}

              {/* Cleanliness */}
              <Typography component="div" sx={{ fontWeight: "bold", marginBottom: 1 }}>
                🧼 Cleanliness
              </Typography>

              <Typography component="div" sx={{ marginBottom: 2 }}>
                <ul style={{ margin: 0, paddingLeft: 20 }}>
                  <li style={{ marginBottom: 6 }}>
                    The chef will ensure the kitchen is <b>tidy</b> (clean countertops & stove).
                  </li>
                  <li>
                    <b>Utensil washing is not included.</b>
                  </li>
                </ul>
              </Typography>

              {/* Closing */}
              <Typography component="div" sx={{ lineHeight: 1.8, }}>
                We look forward to making your event truly special ✨
              </Typography>
              <Typography component="div" sx={{ lineHeight: 1.8, marginBottom: 2 }}>
                Enjoy a seamless and delightful ChefKart experience!
              </Typography>

              <Typography component="div">Warm regards,</Typography>
              <Typography component="div" sx={{ fontWeight: "bold" }}>
                Team ChefKart 👩‍🍳👨‍🍳
              </Typography>
            </DialogContent>

        :
        <DialogContent>
          <Typography component="div" sx={{ marginBottom: 1 }}>
            🎉 <b>Type Of Event:</b> {getTypeOfEvent(props?.data?.time)}
          </Typography>
          <Typography component="div" sx={{ marginBottom: 1 }}>
           👨🏻‍💼 <b>Customer Name:</b> {props?.data?.customerName}
          </Typography>
          {/* <Typography component="div" sx={{ marginBottom: 1 }}>
           ☎️ <b>Customer Phone:</b> {props?.data?.customerPhone}
          </Typography> */}
          <Typography component="div" sx={{ marginBottom: 1 }}>
            📅 <b>Date of Event:</b> {moment(props?.data?.date).format('Do MMMM YYYY')}
          </Typography>
          <Typography component="div" sx={{ marginBottom: 1 }}>
            🕘 <b>Chef Arrival Time:</b> {props?.data?.chefArrivalTime || "N/A"}
          </Typography>
          {!isBookByDish && (
            <>
              <Typography component="div" sx={{ marginBottom: 1 }}>
                ⏰ <b>Food to be Ready by:</b> {props?.data?.time}
              </Typography>
              <Typography component="div" sx={{ marginBottom: 1 }}>
                👨‍👩‍👧‍👦 <b>Number of Pax:</b> {props?.data?.noOfAdults}+{props?.data?.noOfChildren} (adult+children)
              </Typography>
            </>
          )}
          <Typography component="div" sx={{ marginBottom: 1 }}>
            📍 <b>Location:</b>{" "}
            {locationMapLink ? (
                <a href={locationMapLink} target="_blank" rel="noopener noreferrer">
                  {locationMapLink}
                </a>
            ) : (
                props?.data?.cityName
            )}
          </Typography>
          <Typography component="div" sx={{ marginBottom: 1 }}>
            📍 <b>Address:</b>{" "}
            {[
              props?.data?.house?.address,
              props?.data?.house?.localityName,
              props?.data?.house?.areaName,
              props?.data?.house?.cityName,
            ]
                .filter((each) => each !== null)
                .join(", ")}
          </Typography>
          <Typography component="div" sx={{ marginBottom: 1 }}>
            🍽️ <b>Menu:</b>{" "}
            {props?.data?.dishes
                ?.filter((eachDish: any) => eachDish?.deletedAt === null)
                ?.map((eachDish: any) => eachDish?.dishName)
                ?.join(", ") || "N/A"}
          </Typography>
          <Typography component="div" sx={{ marginBottom: 1 }}>
            💵 <b>Payout:</b> ₹{getCookPayout(props?.data?.cooks)[0]}
          </Typography>
          <Typography component="div" sx={{ marginBottom: 1 }}>
            ⏰ <b>Chef to Stay Till:</b> {chefStayTill}
          </Typography>
          <Typography component="div" sx={{ marginBottom: 1 }}>
            💵 <b>Cash Collection:</b> ₹{props?.data?.netPayableAmount}
          </Typography>
          {/*<Divider sx={{ my: 2 }} />*/}
      </DialogContent>
        }
        <DialogActions style={{ marginTop: "12px" }}>
          <Button
              variant="contained"
              color={'success'}
              onClick={handleCopyForWhatsApp}
          >
            Copy For WhatsApp
          </Button>
          <Button
              variant="contained"
              onClick={handleCopy}
          >
            Copy Message
          </Button>
          <Button
              variant="contained"
              color={"error"}
              onClick={handleClose}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
  );
};

export default ChefOrderSummaryDialog;
